import axios from 'axios';
import { User } from '../interfaces/user';
import { Envelope } from '../interfaces/envelope';

async function getUsers(): Promise<User[]> {
	try {
		const response = await axios.get<Envelope<User[]>>(`users`);
		return response.data.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			throw error.response!.data;
		}
		throw error;
	}
}

async function getUser(id: number): Promise<User> {
	try {
		const response = await axios.get<Envelope<User>>(`users/${id}`);
		return response.data.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			throw error.response!.data;
		}
		throw error;
	}
}

export const users = {
	getUsers,
	getUser,
};
